export default "__VITE_ASSET__DvAn9U7X__"